export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

import axios from "axios";

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const formatError = (err) => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
};

export const NGN = (n) => {
  const num = Number(n || 0);
  const formatted = num.toLocaleString("en-NG", { maximumFractionDigits: 0 });
  return `₦${formatted}`;
};

export const NGNk = (n) => {
  // With kobo (2 decimals) — for precise payment amounts
  const num = Number(n || 0);
  return `₦${num.toLocaleString("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
